module.exports = __webpack_public_path__ + "static/media/queue.a4add774.svg";